import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  CreateCompanyEmployeeRequest,
  CreateCompanyEmployeeResponse,
  FetchCompanyEmployeesResponse,
  FetchCompanyEmployeeResponse,
  UpdateCompanyEmployeeRequest,
  UpdateCompanyEmployeeResponse,
  DeleteCompanyEmployeeResponse,
  RestoreCompanyEmployeeResponse,
  ActivateCompanyEmployeeResponse,
  InactivateCompanyEmployeeResponse,
} from '../../../../types/b2tRatibiPlus';
import { ApiResponse, PaginatedRequest } from '../../../../types/api';
import { b2bThriftPlan } from '../../../../api/b2bThriftPlan';

export const fetchCompanyEmployees = createAsyncThunk<
  FetchCompanyEmployeesResponse,
  { companyId: number } & PaginatedRequest
>('companyEmployee/fetch-all', async (params) => {
  const response = await b2bThriftPlan.fetchCompanyEmployees(params);
  return response;
});

export const createCompanyEmployee = createAsyncThunk<
  CreateCompanyEmployeeResponse,
  { companyId: number; payload: CreateCompanyEmployeeRequest }
>('companyEmployee/create', async ({ companyId, payload }) => {
  const response = await b2bThriftPlan.createCompanyEmployee(companyId, payload);
  return response;
});

export const fetchCompanyEmployee = createAsyncThunk<
  FetchCompanyEmployeeResponse,
  { companyId: number; employeeId: number }
>('companyEmployee/fetch-one', async ({ companyId, employeeId }) => {
  const response = await b2bThriftPlan.fetchCompanyEmployee(companyId, employeeId);
  return response;
});

export const updateCompanyEmployee = createAsyncThunk<
  UpdateCompanyEmployeeResponse,
  { companyId: number; employeeId: number; payload: UpdateCompanyEmployeeRequest }
>('companyEmployee/update', async ({ companyId, employeeId, payload }) => {
  const response = await b2bThriftPlan.updateCompanyEmployee(companyId, employeeId, payload);
  return response;
});

export const deleteCompanyEmployee = createAsyncThunk<
  DeleteCompanyEmployeeResponse,
  { companyId: number; employeeId: number }
>('companyEmployee/delete', async ({ companyId, employeeId }) => {
  const response = await b2bThriftPlan.deleteCompanyEmployee(companyId, employeeId);
  return response;
});

export const restoreCompanyEmployee = createAsyncThunk<
  RestoreCompanyEmployeeResponse,
  { companyId: number; employeeId: number }
>('companyEmployee/restore', async ({ companyId, employeeId }) => {
  const response = await b2bThriftPlan.restoreCompanyEmployee(companyId, employeeId);
  return response;
});

export const activateCompanyEmployee = createAsyncThunk<
  ActivateCompanyEmployeeResponse,
  { companyId: number; employeeId: number }
>('companyEmployee/activate', async ({ companyId, employeeId }) => {
  const response = await b2bThriftPlan.activateCompanyEmployee(companyId, employeeId);
  return response;
});

export const inactivateCompanyEmployee = createAsyncThunk<
  InactivateCompanyEmployeeResponse,
  { companyId: number; employeeId: number }
>('companyEmployee/inactivate', async ({ companyId, employeeId }) => {
  const response = await b2bThriftPlan.inactivateCompanyEmployee(companyId, employeeId);
  return response;
});

export const uploadCompanyEmployeesCsv = createAsyncThunk<ApiResponse, { companyId: number; file: File }>(
  'companyEmployee/upload-csv',
  async ({ companyId, file }) => {
    const response = await b2bThriftPlan.uploadCompanyEmployeesCsv(companyId, file);
    return response;
  },
);
